export default{
    mensHealth: 'سلامت مردان',
    womensHealth: 'سلامت زنان',
    pregnantWomen: 'زنان باردار',
    infertility: 'ناباروری',
    legal: 'مشاوره‌ی حقوقی',
    egg_freezer_for_single: 'فریز تخمک (مجرد)',
    egg_freezer_for_married: 'فریز تخمک (متاهل)',
    married_donor: 'اهداکننده (متاهل)',
    divorced_donor: 'اهداکننده (مطلقه)',
    radiology: 'رادیولوژی',
    psychological_advisor: 'مشاوره‌ی روانشناسی',
    glands: 'داخلی- غدد',
    question_from_the_doctor: 'سوال از پزشک',
    visitor: 'ویزیتور',
    service: 'خدمت',
    services: 'خدمات',
    doctor: 'پزشک معالج',
    unit: 'واحد',
    patient: 'بیمار',
    discountGroupId: 'تخفیف',
    presence: 'حضور',
    call: 'فراخوانی',
    endOfPresence: 'اتمام حضور',
    receptionDone: 'اتمام ویزیت',
    triageDone: 'اتمام تریاژ',
    noCharge: 'هزینه پرداخت نشود',
    repeat: 'تکرار شود',
    description: 'توضیحات',
    total: 'مبلغ کل',
    createdAt: 'تاریخ',
    discount: 'تخفیف',
    amount: 'مبلغ',
    returnAmount: 'مبلغ استرداد',
    paymentType: 'نحوه‌ی پرداخت',
    pastPayments: 'پرداخت شده',
    pos: 'پوز',
    room: 'اتاق',
    factor: 'فاکتور',
    payable: 'قابل پرداخت',
    subTotal: 'مجموع',
    subDiscount: ' تخفیف',
    addService: 'ثبت خدمت',
    startAndEndOfPresence:'شروع و پایان حضور پزشکان',
    firstName: 'نام',
    patientsName: 'نام بیمار',
    showReceipt: 'مشاهده‌ی فاکتور',
    tabs:{addService: 'ثبت خدمت', medicalRecords:'پرونده پزشکی', postReferrals: 'مراجعات پیشین', profile: 'پروفایل'},
    bankCard: 'کارت بانکی',
    pay: 'پرداخت',
    addExcessReceived: 'اضافه دریافت',
    excessReceived: 'اضافه دریافت',
    sendToQueue: 'ارسال به صف',
    sendToCashier: 'ارسال به کارتابل صندوق ',
    sendToQueueWithoutPayment: 'ارسال به صف بدون پرداخت ویزیت',
    sendToQueueWithPayment: 'ارسال به صف با پرداخت ویزیت',
    callingNumber: 'شماره فراخوانی',
    waitingTime:'زمان انتظار',
    excessRequest: 'درخواست استرداد',
    excessRequestAndSubmission: 'ثبت و درخواست استرداد',
    returnReason: 'علت استرداد',
    returnDescription: 'عنوان استرداد',
    medicalRecords:{
        infertility: 'ناباروری',
        gynecology: 'سلامت',
        obstetric: 'بارداری',
        glands: 'داخلی(غدد) ',
        genetics: 'ژنتیک',
        nourish: 'تغذیه',
        urology: 'ارولوژی',
        legal: 'حقوقی',
        lab: 'آزمایشگاه',

    },
    returnTypes:{
        hospital: 'بیمارستان',
        doctor: 'پزشک',
        doctorAndHospital: 'پزشک و بیمارستان',
    },
    serviceReturn: 'استرداد خدمت',
    returnSubmission: 'ثبت استرداد خدمت',
    select: 'انتخاب',
    status: 'وضعیت',
    currentServiceReturns: 'خدمات استرداد شده',
    includeExcessReceived: 'درخواست استرداد اضافه دریافت ها',
    returnStatuses:{
        requestReturn: 'درحال بررسی',
        confirmReturn: 'تایید شده',
    },
    accountingStatuses:{
        debtor: 'بدهکار',
        checkout: 'تسویه شده',
        withoutServiceAndPayment: 'بدون سرویس و پرداخت',
        completeDiscount: 'تخفیف کامل'
    },
    receptionPaymentDone:"اتمام پذیرش و تسویه حساب",
    printFactor: 'چاپ فاکتور',
    printAgain: 'چاپ مجدد',
    selectFromSections: 'از بین بخش های موجود بخش مورد نظر را انتخاب کنید',
    selectFromUnits: 'از بین واحد های موجود بخش مورد نظر را انتخاب کنید',
    legacy: 'آپلود پرونده قدیمی',
    oldReceptionsConsulates: 'مراجعات حقوقی پیشین',
    oldReceptionsًReferrals: 'مراجعات سیستم HIS پیشین',
    oldReception:{
        male: 'آقا',
        firstName: 'نام',
        lastName: 'نام خانوادگی',
        female: 'خانم',
        receptionDate: 'تاریخ مراجعه',
        doctorName: 'پزشک',
        legalVisitType: 'علت مراجعه',
        consultationId: 'مشاور',
        status: 'وضعیت',
    },
    doneAccounting: 'تسویه حساب',
    doneReceptions: 'ویزیت‌های پایان یافته',
    currentReceptions: 'ویزیت‌های جاری',
    areYouSureOfDeletion: 'آیا از حذف مراجعه‌ی {item} اطمینان دارید؟',
    currentDayReception:{
        doctor: 'پزشک',
        fullName: 'نام بیمار',
        nationalCode: 'کدملی',
        insurance: 'بیمه',
        createdUser: 'کاربر ایجاد کننده',
        date:'تاریخ',
        completeReferral: 'تکمیل مراجعه',
        currentDayReceptionStatus: 'وضعیت'
    },
    receptionStatuses:{
        inRoom:'در اتاق',
        triage:'در اتاق (در حال تریاژ)',
        doneTriage:'در اتاق (تریاژ شده)',
        preWaiting:'معلق',
        waiting:'در انتظار',
    },
    backToQueue: 'بازگشت به صف',
editAPayment: 'ویرایش پرداخت',
    onlyPaymentDescription: 'مبلغ فوق بابت تسویه خدمات : {services} می‌باشد.'

}
